/*=========================================================================================
  File Name: moduleSpaceMutations.js
  Description: Space Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  UPDATE_ALARM(state, payload) {
    var index = state.alarms.findIndex(function(item){return item.id == payload.id})
    if (index != -1){
      state.alarms[index].unread = false
      state.unreadAlarmCount = state.unreadAlarmCount - 1
    }
    index = state.newAlarms.findIndex(function(item){return item.id == payload.id})
    if (index != -1){
      state.newAlarms.splice(index,1)
    }
  },
  DELETE_ALARM(state, payload) {
    var index = state.alarms.findIndex(function(item){return item.id == payload})    
    if(index != -1){
      state.alarms.splice(index,1)
    }
  },
  SET_NEW_ALARM_LIST(state, payload){
    state.newAlarms = payload
    state.unreadAlarmCount = state.newAlarms.length
  },
  SET_ACTIVE_ALARM(state, payload) {
    state.ActiveAlarm = payload
  },
  SET_ALARM_LIST(state, payload){
    if (payload){
      state.alarms = payload.sort(function(a,b) {return a.create_time > b.create_time ? -1 : a.create_time > b.create_time ? 1 : 0})
      state.ActiveAlarm = state.alarms[0]
    } else {
      state.alarms = []
      state.ActiveAlarm = {
          title:'',
          detail:'',
          id:0
      }
    }
  },
  UPDATE_ALARM_FILTER(state, payload){
    state.alarmFilter = payload
  },
  SET_ALARM_SEARCH_QUERY(state, query) {
      state.alarmSearchQuery = query
  },
}
